import { VotingRegion } from '../apps/audience/hooks/useVotingRegion.js'
import type { ParticipatingVotingRegionsResponse } from '../functions/audience/participating-voting-regions/index.js'
import { Errors } from './errors.js'

export const checkEligibleCardGeo = (
  participatingVotingRegions: ParticipatingVotingRegionsResponse,
  region: VotingRegion,
  cardGeo: string,
) => {
  if (typeof cardGeo !== 'string' || !cardGeo) {
    throw new Error('No cardGeo')
  }

  if (
    typeof participatingVotingRegions !== 'object' ||
    !Object.keys(participatingVotingRegions).length
  ) {
    throw new Error('No participatingVotingRegions')
  }

  // TODO: This is the frontend version. Should be unified
  const regionCode: string | undefined = region?.code || region.name
  if (!regionCode) {
    throw new Error('No regionCode')
  }

  if (regionCode === 'ROW') {
    // INFO: RULE: if region is ROW you cannot be in participating countries
    if (participatingVotingRegions[cardGeo]) {
      throw new Error(Errors.CardNotEligible)
    }
  } else {
    // INFO: RULE: if region is not ROW region needs to be your country or territory
    const myCardCountry = participatingVotingRegions[cardGeo]
    if (!myCardCountry) {
      throw new Error(Errors.CardNotEligible)
    }
    if (myCardCountry.name !== regionCode) {
      if (myCardCountry.isTerritoryOf?.name !== regionCode) {
        throw new Error(Errors.CardNotEligible)
      }
    }
  }
}
